// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {2276: "2ca84e5e53fc28a8",6928: "a88eace2d55b382b",8638: "da992fcdee8bb020",}[chunkId] + ".css"
}